<template>
  <div>
    <a @click.prevent="handleClick" class="a">
      <v-btn text class="font-italic"
        ><v-icon>mdi-lock-question</v-icon>
        <p class="text-capitalize my-auto">¿Olvide</p>
        <p class="text-lowercase my-auto">la contraseña?</p>
      </v-btn>
    </a>

    <p v-if="clicked && !show" style="color: red">
      {{ $tc("login.enterValidEmail") }}
    </p>

    <v-dialog
      v-model="showAdd"
      max-width="500px"
      transition="scale-transition"
      position-y="top"
      @keydown.esc="cancel()"
      persistent
    >
      <v-card>
        <v-toolbar :color="toolbarColor" dark height="40px">
          <v-toolbar-title>{{ $tc("login.resetPass") }}</v-toolbar-title>
        </v-toolbar>

        <div class="text-center mt-3">
          <h3>{{ $tc("login.confirmForgotPass") }}</h3>
          <div class="mt-3 d-flex justify-center">
            <v-icon
              class="mr-1"
              :style="{ color: getToolbarColor(toolbarColor) }"
              >mdi-email-outline</v-icon
            >
            <h4
              :style="{
                color: getToolbarColor(toolbarColor),
                textTransform: 'lowercase',
              }"
            >
              {{ email }}
            </h4>
          </div>

          <p class="mt-3" :style="{ color: getToolbarColor(toolbarColor) }">
            {{ textAlert }}
          </p>
        </div>

        <v-card-actions mt-3>
          <v-spacer />
          <v-btn
            @click="cancel"
            color="dark"
            class="btn-transition btn-cancel"
            text
          >
            {{ $tc("commons.cancel") }}
          </v-btn>
          <v-btn
            @click="add"
            text
            class="btn-transition btn-accept"
            style="color: #82a1d0"
          >
            {{ $tc("commons.accept") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import login from "../../store/login/login";

export default {
  props: {
    email: String,
    show: Boolean,
  },

  data() {
    return {
      showAdd: false,
      toolbarColor: "#82A1D0",
      textAlert: "",
      clicked: false,
    };
  },

  methods: {
    handleClick() {
      if (this.show) {
        this.showAdd = true;
      } else {
        this.clicked = true;
      }
    },

    getToolbarColor(toolbarColor) {
      return toolbarColor === "red darken-3"
        ? "red"
        : toolbarColor === "blue darken-3"
        ? "blue"
        : "#82A1D0";
    },

    cancel() {
      this.showAdd = false;
      this.toolbarColor = "#82A1D0";
      this.textAlert = "";
    },

    add() {
      const payload = { email: this.email };

      login.commit("setUser", payload);

      login
        .dispatch("forgotPass")
        .then(() => {
          this.toolbarColor = "green darken-3";
          this.textAlert = this.$tc("login.changePassOk");
          setTimeout(() => {
            this.cancel();
          }, 2500);
        })
        .catch((error) => {
          this.textAlert = this.$tc("login.changePassFail");
          this.toolbarColor = "red darken-3";
          setTimeout(() => {
            this.cancel();
          }, 2500);
        });
    },
  },
};
</script>
